import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";

const NAV_ITEMS = [
  { icon: "\uD83C\uDFE0", label: "Accueil", path: "/" },
  { icon: "\uD83E\uDE7A", label: "Consulter", path: "/chat" },
  { icon: "\uD83D\uDC3E", label: "Animaux", path: "/animaux" },
  { icon: "\uD83D\uDC64", label: "Profil", path: "/profil" },
];

const ADMIN_ITEM = { icon: "\uD83D\uDEE1\uFE0F", label: "Admin", path: "/admin" };

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const items = user?.is_admin ? [...NAV_ITEMS, ADMIN_ITEM] : NAV_ITEMS;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/94 backdrop-blur-lg border-t border-pawcare-orange/20 flex justify-around py-2.5 shadow-[0_-6px_28px_rgba(255,112,85,0.08)] z-50" style={{ paddingBottom: "max(20px, env(safe-area-inset-bottom, 20px))" }}>
      {items.map((item) => {
        const active = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-1 px-3 outline-none"
          >
            <div
              className={cn(
                "w-11 h-11 rounded-[14px] text-[22px] flex items-center justify-center transition-all duration-300",
                active
                  ? "bg-pawcare-gradient shadow-[0_4px_14px_rgba(255,112,85,0.45)] scale-110"
                  : "bg-transparent scale-100"
              )}
            >
              {item.icon}
            </div>
            <span
              className={cn(
                "text-[10px] font-bold transition-colors",
                active ? "text-pawcare-coral" : "text-app-subtle"
              )}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
